module.exports = __webpack_public_path__ + "img/delhivery-logo.be0cccbe.svg";